export function identify(claims) {
  const dummyValue = "dummy_user_value"

  const checkIfTrimbleUser = (claims) => {
    if (claims.account_id && claims.account_id.startsWith("trimble")) {
      return true
    }

    if (claims.amr.includes("trimble_automation")) {
      return true
    }

    return false
  }

  const userData = {
    id: claims.sub,
    email: dummyValue,
    firstName: dummyValue,
    lastName: dummyValue,
    isTrimbleUser: checkIfTrimbleUser(claims)
  }

  window.aptrinsic("identify", userData)
}

export function track(event, properties) {
  if (!window.aptrinsic) {
    return
  }

  window.aptrinsic("track", event, properties)
}
